import { useEffect } from 'react';  
import axios from 'axios';  
  
export default function useSessionExtensionInterceptor(resetSessionTimer) {  
  useEffect(() => {  
    if (!resetSessionTimer) return;  
  
    // Request interceptor - extend session on every request  
    const requestInterceptor = axios.interceptors.request.use(  
      config => {  
        // Reset session timer on every HTTP request  
        console.log('Extending session due to HTTP request');
        resetSessionTimer();  
        return config;  
      },  
      error => {  
        return Promise.reject(error);  
      }  
    );  
  
    // Cleanup on unmount  
    return () => {  
      axios.interceptors.request.eject(requestInterceptor);  
    };  
  }, [resetSessionTimer]);  
}